module.exports = __webpack_public_path__ + "img/104.1.044706a6.jpg";